  /* --- Header Color Handling when Menu/Search opens --- */
  const detailsElements = document.querySelectorAll('#Details-menu-drawer-container, .header__search > details');
  const header = document.querySelector('.header-wrapper');
  const slideshow = document.querySelector('slideshow-component');

  if (detailsElements.length) {
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          const el = mutation.target;
          let activeSlide = slideshow.querySelector('.slideshow__slide[aria-hidden="false"]');
          const isAnyMenuOrSearchOpen = Array.from(detailsElements).some(elem => elem.open);
          const isDesktopSearchOpen = document.querySelector('.header__search > details').open && screen.width > 1199;

          if(!activeSlide) {
            activeSlide = slideshow.querySelector('.slideshow__slide');
          }

          if (!document.querySelector('.header-wrapper').classList.contains("header-wrapper--not-sticky")) {
            if (isAnyMenuOrSearchOpen && !isDesktopSearchOpen) {
              header.classList.remove('tw-bg-transparent');
              header.classList.remove(activeSlide.dataset.colorScheme);
              header.classList.add(header.dataset.colorScheme);
            } else {
              header.classList.add('tw-bg-transparent');
              header.classList.remove(header.dataset.colorScheme);
              header.classList.add(activeSlide.dataset.colorScheme);
            }
          }
        }
      }
    });

    detailsElements.forEach((el) => {
      observer.observe(el, { attributes: true, attributeFilter: ['open'] });
    });
  }

  /* --- Cursor-Following Buttons (Prev / Next) --- */
  const prevBtn = document.querySelector('.slider-button--prev');
  const nextBtn = document.querySelector('.slider-button--next');
  const bannerButtons = document.querySelectorAll('.banner__buttons');

  let activeSide = null;

  if (prevBtn) {
    // Move buttons with cursor and show based on side
    slideshow.addEventListener('mousemove', (e) => {
      const rect = slideshow.getBoundingClientRect();
      const midpoint = rect.left + rect.width / 2;
  
      // Hide buttons when hovering banner buttons
      if (e.target.closest('.banner__buttons')) {
        nextBtn.style.opacity = '0';
        prevBtn.style.opacity = '0';
        return;
      }
  
      if (e.clientX < midpoint) {
        activeSide = 'left';
        prevBtn.style.left = `${e.clientX}px`;
        prevBtn.style.top = `${e.clientY}px`;
        prevBtn.style.opacity = '1';
        nextBtn.style.opacity = '0';
      } else {
        activeSide = 'right';
        nextBtn.style.left = `${e.clientX}px`;
        nextBtn.style.top = `${e.clientY}px`;
        nextBtn.style.opacity = '1';
        prevBtn.style.opacity = '0';
      }
    });
  
    // hide Prev / Next when hovered outside slideshow
    slideshow.addEventListener('mouseleave', () => {
      nextBtn.style.opacity = '0';
      prevBtn.style.opacity = '0';
    });
  
    slideshow.addEventListener('click', (e) => {
      const rect = slideshow.getBoundingClientRect();
      const midpoint = rect.left + rect.width / 2;
  
      // Check if a button was clicked before moving slides
      if (!e.target.closest(".banner__buttons")) {
        // Decide which direction to go
        const direction = e.clientX < midpoint ? 'prev' : 'next';
        const step = 1;
    
        // Trigger the slideshow component built-in method directly
        if (direction === 'prev') {
          slideshow.onButtonClick({
            preventDefault: () => {},
            currentTarget: { name: 'prev', dataset: { step } }
          });
        } else {
          slideshow.onButtonClick({
            preventDefault: () => {},
            currentTarget: { name: 'next', dataset: { step } }
          });
        }
      }
    });
  }
  